import type { BaseResponse } from "~/@types";
import { http } from "~/libs/axios";

// Kosakata status marketplace berbeda dengan verifikasi dokumen.
export type MarketplaceStatus = "pending" | "verified" | "invalid";

export interface MarketplaceIntegration {
  _id: string;
  url: string;
  platform?: string | null; // Shopee | Tokopedia | TikTok Shop | Lazada | Bukalapak | Lainnya
  status: MarketplaceStatus;
  httpStatus?: number | null;
  message?: string | null; // alasan berbahasa Indonesia, tampil saat status invalid
  checkedAt?: string | null;
  createdAt: string;
}

type MarketplaceListResponse = BaseResponse & { data: MarketplaceIntegration[] };
type MarketplaceResponse = BaseResponse & { data: MarketplaceIntegration };

export const marketplace = {
  // Daftar tautan toko online milik user.
  getMine: () => http<MarketplaceListResponse>("GET", { url: "/marketplace" }),

  // Hubungkan tautan toko. Server melakukan ping & deteksi platform, status yang
  // dikembalikan sudah final — frontend tidak perlu mem-parsing URL.
  connect: (url: string) => http<MarketplaceResponse>("POST", { url: "/marketplace", data: { url } }),
};
